export var config = {
  employerTermsUrl: 'https://www.restworld.it/termini-employer',
  workerTermsUrl: 'https://www.restworld.it/termini-worker',
  restworldPrivacyUrl: 'https://www.restworld.it/privacy-policy',
  restworldCookiePolicyUrl: 'https://www.restworld.it/cookie-policy',
  restworldDpaUrl: 'https://www.restworld.it/dpa',
  accomodationPartnerUrl: 'https://housinganywhere.com/it/register/8474',
  learningPartnerUrl: 'https://ac.academia.tv/restworld',
  hireWithRestworldUrl: 'https://www.restworld.it/aziende'
};